import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoOrcamentoReprovado from './ContentSolicitacaoFluxoOrcamentoReprovado';

const SolicitacaoFluxoOrcamentoReprovado = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoOrcamentoReprovado />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoOrcamentoReprovado;
